import styled from 'styled-components';

import breakpoints, { under } from '@polyai/ui/styles/config/breakpoints';

/**
 * Shared wrapper component for AgentWizard screens
 * Includes banner offset handling for proper positioning when banner is shown
 */
export const Wrapper = styled.div<{ $bannerOffset: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: absolute;
  top: ${({ $bannerOffset }) => $bannerOffset}px;
  bottom: 0;
  width: 100%;

  @media ${under(breakpoints.sm)} {
    grid-template-columns: 1fr;
  }
`;
